import { useEffect } from "react";
import { useWebSocket } from "../context/WebSocketContext";
import { useAppContext } from "../context/AppContext";
import { logSecretly } from "../utils/logSecretly";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { WS_EVENTS } from "../constants";
import { markSessionAwaitingReport } from "../utils/podSessionReport";

/**
 * Listens for the WebSocket SESSION_ENDED event.
 * When received, it automatically logs the user out and resets the pod state,
 * returning the pod to the Welcome screen.
 */
export function useSessionEndedListener(): void {
    const { subscribe } = useWebSocket();
    const { resetState } = useAppContext();
    const { isAuthenticated, isLoggingOut, session } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        const unsubscribe = subscribe(WS_EVENTS.SESSION_ENDED, async (data: any) => {
            if (!isAuthenticated || isLoggingOut) {
                return;
            }
            logSecretly("Received SESSION_ENDED event, resetting pod...", data);
            // Remember the session we're about to drop — its PDF report event
            // arrives afterwards and is matched against this id.
            markSessionAwaitingReport(data?.sessionId ?? session?.sessionId);
            resetState();
            // The report for this session is on its way — wait for it there
            // rather than on Welcome, which would churn QR codes behind it.
            navigate("/session-report")
        });

        return () => unsubscribe();
    }, [subscribe, resetState, isAuthenticated, isLoggingOut, session?.sessionId]);
}
